import { render } from "./UserProfile.vue?vue&type=template&id=decd597e&ts=true"
import script from "./UserProfile.vue?vue&type=script&lang=ts"
export * from "./UserProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__